module.exports = __webpack_public_path__ + "img/english_flag_colored.8eb05785.png";